import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import authReducer from "../store/auth/authState";
import authUser from "../store/auth/user";
import loginUi from "../store/ui/loginUi";

const combineReducer = combineReducers({
  auth: authReducer,
  user: authUser,
  login: loginUi,
});

const store = configureStore({
  reducer: combineReducer,
});

export default store;
